export { default } from './InternalLinkModule';
